import NextLink from 'next/link'
import { Button as BaseButton, ButtonProps as BaseButtonProps } from '@careguide/button'
import { FC } from 'react'

type ButtonProps = BaseButtonProps & {
  scroll?: boolean
  replace?: boolean
}

const Button: FC<ButtonProps> = ({ href, children, scroll = true, replace = false, ...props }) => {
  return href ? (
    <NextLink href={href} scroll={scroll} replace={replace} passHref>
      <BaseButton as='a' {...props}>
        {children}
      </BaseButton>
    </NextLink>
  ) : (
    <BaseButton as='button' {...props}>
      {children}
    </BaseButton>
  )
}

export default Button
